import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ContextoAtivoRef, ContextosResponse } from '@/types/contextoAcesso/types';

import { contextoAcessoService } from './services';

export const carregarContextos = createAsyncThunk<ContextosResponse, void, { rejectValue: string }>(
  'contextoAcesso/carregar',
  async (_, { rejectWithValue }) => {
    try {
      return await contextoAcessoService.listar();
    } catch (erro) {
      return rejectWithValue((erro as Error).message);
    }
  },
);

export const promoverSessao = createAsyncThunk<void, void, { rejectValue: string }>(
  'contextoAcesso/promover',
  async (_, { rejectWithValue }) => {
    try {
      await contextoAcessoService.promover();
    } catch (erro) {
      return rejectWithValue((erro as Error).message);
    }
  },
);

export const trocarContexto = createAsyncThunk<
  ContextoAtivoRef,
  ContextoAtivoRef,
  { rejectValue: string }
>('contextoAcesso/trocar', async (contexto, { rejectWithValue }) => {
  try {
    return await contextoAcessoService.trocar(contexto);
  } catch (erro) {
    return rejectWithValue((erro as Error).message);
  }
});
